import clsx from 'clsx';

export const section = clsx(
  'px-10',
  'py-20',
  'md:px-48',
  'md:py-14',
  'bg-background',
  'text-center'
);

export const container = clsx(
  'flex',
  'flex-col',
  'md:flex-row',
  'md:gap-40',
  'items-center',
  'justify-center'
);

export const content = clsx('flex', 'flex-col');

export const titleText = clsx(
  'title',
  'text-[26px]',
  'md:text-3xl',
  'font-semibold',
  'mb-6',
  'text-title',
  'text-center',
  'md:text-left'
);

export const descriptionText = clsx(
  'font-subtitle',
  'text-[14px]',
  'md:text-[15px]',
  'text-description',
  'text-center',
  'md:text-left',
  'tracking-normal'
);

export const arrow = clsx(
  'absolute',
  'top-1/2',
  '-translate-y-1/2',
  'z-20',
  'cursor-pointer',
  'select-none',
  'p-2',
  'transition-transform',
  'duration-300',
  'hover:scale-110'
);

export const leftArrow = clsx(
  'absolute',
  'md:left-0',
  'left-4',
  'top-1/2',
  '-translate-y-1/2',
  'p-2',
  'hover:scale-110'
);

export const rightArrow = clsx(
  'absolute',
  'md:right-0',
  'right-4',
  'top-1/2',
  '-translate-y-1/2',
  'p-2',
  'hover:scale-110'
);

export const slide = clsx('!flex', '!justify-center');

export const slideContainer = clsx(
  'mt-10',
  'md:mt-0',
  'max-w-xl',
  'relative',
  'flex',
  'justify-center',
  'items-center',
  'w-full'
);

export const frame = clsx(
  'relative',
  'overflow-hidden',
  'rounded-2xl',
  'shadow-lg',
  'transition-transform',
  'w-[300px]',
  'md:w-[420px]',
  'aspect-[3/4]'
);

export const frameActive = clsx('scale-100', 'opacity-100');

export const frameInactive = clsx('scale-90', 'opacity-40');

export const image = clsx(
  'w-full',
  'h-full',
  'object-cover',
  'select-none',
  'draggable-none'
);
